import React from 'react'
import styled from 'styled-components'
import hexToRgba from 'hex-to-rgba'
import colors from '@constants/colors'

export default ({ onClick, text, disabled }) => {
    return (
        <InputButton onClick={onClick} disabled={disabled}>
            {text}
        </InputButton>
    )
}

const InputButton = styled.button`
    margin-right: 12px;
    padding: 4px 12px;
    border-radius: 4px;
    white-space: nowrap;
    color: ${colors.APP_WHITE};
    background-color: ${(p) =>
        p.disabled ? hexToRgba(colors.BUTTON_DARK, 0.5) : colors.BUTTON_DARK};
`
